import React, { FunctionComponent } from 'react';

type Page404Props = { 'data-test-id'?: string };

export const Page404: FunctionComponent<Page404Props> = ({ 'data-test-id': testId = '' }) => (
  <div data-test-id={testId}>
    {"It appears the page you're looking for is empty. Try one of the links above..."}
  </div>
);
